import { render, staticRenderFns } from "./warnType.vue?vue&type=template&id=48811c1a&scoped=true"
import script from "./warnType.vue?vue&type=script&lang=js"
export * from "./warnType.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48811c1a",
  null
  
)

export default component.exports